import {
  BusinessDays_TOKYO_NAGOYA_OSAKA,
  BusinessDays_FUKUOKA_SAPPORO
} from './business-days'
import { DaysOfWeek } from './date-util'

export default class ClinicConstantsWomenProd {
  /* clinic情報 */
  static SAPPORO = {
    medicalBusinessId: '362a8a35-7a66-4e30-be2a-d87b22723ad4', // mensのDクリニック札幌へ
    name: '札幌',
    clinicId: '3139273e84784bd0baadbce33fd2e617',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays_FUKUOKA_SAPPORO,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: true } }
  }

  static TOKYO = {
    medicalBusinessId: 'cead4e55-0630-4ad7-b741-71dce1cbcbe6',
    name: '東京',
    clinicId: '4c601981555e4019982200e72385c607',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays_TOKYO_NAGOYA_OSAKA,
    nonTargetDays: { [DaysOfWeek.WED]: { am: true, pm: false } }
  }

  static NAGOYA = {
    medicalBusinessId: 'cead4e55-0630-4ad7-b741-71dce1cbcbe6', // mensのDクリニック名古屋へ
    name: '名古屋',
    clinicId: '29444aeaa45949ee9d659972acd6bd14',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays_TOKYO_NAGOYA_OSAKA,
    nonTargetDays: {
      [DaysOfWeek.WED]: { am: true, pm: false }
    }
  }

  static OSAKA = {
    medicalBusinessId: 'cead4e55-0630-4ad7-b741-71dce1cbcbe6',
    name: '大阪',
    clinicId: 'df39f375795e46f586db7a6368667050',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays_TOKYO_NAGOYA_OSAKA,
    nonTargetDays: { [DaysOfWeek.WED]: { am: true, pm: false } }
  }

  static FUKUOKA = {
    medicalBusinessId: 'cead4e55-0630-4ad7-b741-71dce1cbcbe6',
    name: '福岡',
    clinicId: '3e304f61b50e4acd8a889a922094477b',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays_FUKUOKA_SAPPORO,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: true } }
  }

  static CLINICS = [
    ClinicConstantsWomenProd.SAPPORO,
    ClinicConstantsWomenProd.TOKYO,
    ClinicConstantsWomenProd.NAGOYA,
    ClinicConstantsWomenProd.OSAKA,
    ClinicConstantsWomenProd.FUKUOKA
  ]
}
